import { render } from "./Investments.vue?vue&type=template&id=c9b35354&scoped=true"
import script from "./Investments.vue?vue&type=script&lang=js"
export * from "./Investments.vue?vue&type=script&lang=js"

import "./Investments.vue?vue&type=style&index=0&id=c9b35354&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b35354"]])

export default __exports__